import { device } from "@utils";
import { Button } from "antd";
import { AnchorButtonProps, BaseButtonProps, NativeButtonProps } from "antd/es/button/button";

import styled from "styled-components";

type ButtonProps = Partial<
  BaseButtonProps & NativeButtonProps & AnchorButtonProps & { text?: string }
>;
export const SharedButton = (props: ButtonProps) => {
  return (
    <StyledButton>
      <Button {...props}>{props.children}</Button>
    </StyledButton>
  );
};

export const SharedIconButton = (props: ButtonProps) => {
  return (
    <StyledIconButton>
      <Button {...props}>{props.children}</Button>
    </StyledIconButton>
  );
};

export const SharedDoseIconButton = (props: ButtonProps) => {
  return (
    <StyledDoseIconButton>
      <Button {...props}>{props.children}</Button>
    </StyledDoseIconButton>
  );
};

const StyledButton = styled.div`
  .ant-btn {
    min-width: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 8px;
    &.ant-btn-lg {
      height: 56px;
    }
  }
`;

const StyledIconButton = styled.div`
  .ant-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 8px;
    color: #fff;
    &:hover {
      color: #fff;
      border-color: inherit;
    }
    &.ant-btn-lg {
      height: 56px;
    }
  }
`;

const StyledDoseIconButton = styled.div`
  display: inline-block;
  margin: 0 3px;
  .ant-btn {
    padding: 2px;
    color: #fff;
    width: 27px;
    height: 27px;
    line-height: 27px;
    &:hover {
      color: #fff;
      border-color: inherit;
    }
    &.ant-btn-lg {
      height: 56px;
    }
    svg {
      width: 100%;
      height: 100%;
    }
  }
`;
